import { render, staticRenderFns } from "./EmpresaDetalle.vue?vue&type=template&id=e6170676&scoped=true"
import script from "./EmpresaDetalle.vue?vue&type=script&lang=js"
export * from "./EmpresaDetalle.vue?vue&type=script&lang=js"
import style0 from "./EmpresaDetalle.vue?vue&type=style&index=0&id=e6170676&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6170676",
  null
  
)

export default component.exports